<template>
  <div class="region-fields">
    <div class="box">
      <form class="form" v-on:submit.prevent="createRegion">
        <fieldset>
          <div class="form-wrap">
            <div>
              <label for="region_name">Region Name</label>
              <input id="region_name" name="region_name" v-model="newRegion.region_name" type="text" required/>
          </div>
          <div class="form-submit-inline">
            <template v-if="this.$data.loading">
              <button type="submit" class="button" disabled><span>Adding pickup region...</span></button>
            </template>
            <template v-else>
              <button type="submit" class="button"><span>Add pickup region</span></button>
            </template>
          </div>
        </div>
      </fieldset>
    </form>
    <table class="table" cellspacing="0" cellpadding="0">
      <thead v-if="this.$data.regions.length > 0">
        <tr>
          <th>Region Name</th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="region of this.$data.regions" :key="region.id">
          <td>{{region.region_name}}</td>
          <td class="table-action"><a v-on:click="doRouteEdit(region)" class="icon icon--more">Edit</a></td>
          <td class="table-action"><a v-on:click="deleteRegion(region.id)" class="icon icon--delete">Delete</a></td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  export default {
    name: 'RegionsFields',
    components: mapGetters(['getLoadStatus']),
    data() {
      return {
        loading: false,
        regions: [],
        newRegion: {},
      }
    },
    created() {
      this.getRegions()
    },
    methods: {
      doRouteEdit(data) {
      this.$router.push({ name: 'regions-edit', params: { id: data.id }})
      },
      getRegions() {
        this.$store.dispatch('setLoadStatus')
        fetch( this.$api + 'pickup/regions/', {
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.$store.dispatch('setLoadStatus')
          this.$data.regions = response.data
        })
      },
      createRegion() {
        this.$data.loading = true
        fetch(this.$api + 'pickup/regions', {
          method: 'POST',
          body: JSON.stringify(this.newRegion),
          headers:{
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.$notify({
            type: 'success',
            title: response.message
          });
          this.getRegions()
          this.newRegion = {}
          this.$data.loading = false
        })
      },
      deleteRegion(data) {
        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'pickup/regions/' + data + '/delete', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.errors = response.errors
          if(response.success == true) {
            this.getRegions()
            this.$notify({
              type: 'success',
              title: response.message
            });
          } else if (response.errors) {
            this.$notify({
              type: 'error',
              title: response.message
            })
          } else {
            this.$notify({
              type: 'error',
              title: response.Error
            })
          }
          this.$store.dispatch('setLoadStatus')
        })
      },
    }
  }
</script>
